import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { ExperienceService, SessionService } from '@app/core';

import { Experience } from '@common/enums';


@Injectable()
export class ConversationsRedirectGuard  {
  router = inject(Router);
  private _experienceService = inject(ExperienceService);
  private _sessionService = inject(SessionService);


  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (state.url === '/conversations' &&
      (this._experienceService.isExperienceParent ||
        this._sessionService.account().lastExperience === Experience.Parent)
    ) {
      const url = state.url.replace('/conversations', '/parent/inbox');

      return this.router.parseUrl(url);
    }

    return true;
  }

}
